import { Button, Checkbox, Col, Form, Input, Popover, Radio, Row, Space, Typography } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { ConfigStateContext } from "../../../../Contexts/Configurations/context";
import { DateSelector } from "./DateSelector/web";
import { Grid } from "antd";
import { LeadButtons } from "../LeadButtons/web";
import { QuestionCircleOutlined } from "@ant-design/icons";
import cookie from "js-cookie";
import { openAuthModal } from "../../../../Components/User/AuthModal/openAuthModal";
import { useContact, VisitType } from "../hook";
import { useFacebookPixel } from "../../../../GlobalHooks/web/FacebookPixel.hook";
import { useRouter } from "next/router";
import { useUser } from "../../../User/User.hook";
import dayjs from "dayjs";
import getConfig from "next/config";
import IcBuscaPorTi from "shared-components/Components/PopUps/IcBuscaPorTi/web";
import { QuestionIcon } from "shared-components/Components/CustomIcons/QuestionIcon/web";
import CheckboxCustomInput from "shared-components/Components/CheckboxCustomInput";
import "./styles.less";
import { isValidCharactersXSS, isValidEmail, isValidPhone } from "@Utils/Functions";
import { CountriesDropdown } from "shared-components/Components/Dropdowns/CountriesDropdown/web";
import { CountryCode, isValidPhoneNumber, parsePhoneNumberWithError } from "libphonenumber-js";
import { phoneStartWithIndicative } from "@Utils/phones";
import { getInitCountryCode, getInitialContactForm } from "../LeadButtons/PhoneButton/web";

type FormDataTypes = {
	name: string;
	phone: string;
	email: string;
	fincatyc: boolean;
};
type FormErrorTypes = {
	name: boolean;
	phone: boolean;
	email: boolean;
	fincatyc: boolean;
};

const { NODE_ENV } = getConfig().publicRuntimeConfig;

const { useBreakpoint } = Grid;

const { Text } = Typography;

export const ScheduleVisitForm = ({
	id,
	onComplete = null,
	form,
	identifier = 1,
	mode,
	disabled = false,
	isInListing = false,
	isProjectSpecialPage = false,
	slug = "",
	projectId = null,
	isFromPaidTraffic = null,
	isProject = false,
}) => {
	const screens = useBreakpoint();
	const Router = useRouter();
	const [show, setShow] = useState(false);
	const { loginBasePath } = getConfig().publicRuntimeConfig;
	const [selectedCountryCode, setSelectedCountryCode] = useState<{
		code: CountryCode;
		value: string;
	}>({
		// This code should be a setting, depending the website
		code: "CO",
		value: "+57",
	});

	const {
		sendContact,
		resetForm,
		formCompleted,
		loading,
		disabledEmail,
		dataRegisterMutation,
		doContactMutation,
		dataUserExist,
		userExistsCustomQuery,
		registerMutation,
		updateUser,
		isSendedConsultation,
	} = useContact({
		id,
		onComplete,
		type: "schedule",
		mode,
		source: isInListing ? 22 : screens.lg ? 0 : 4,
		utm: Router.query,
		env: NODE_ENV == "development" || NODE_ENV == "beta" ? "development" : "production",
	});

	const { user, isLoggedIn } = useUser();
	const { country_code, site_name } = useContext(ConfigStateContext);
	// const GA = useGoogleAnalytics();
	const FP = useFacebookPixel();

	const [selectedDate, setSelectedDate] = useState(null);
	const [formData, setFormData] = useState<FormDataTypes>({
		name: user?.data?.me?.name ?? "",
		phone: user?.data?.me?.phone ?? "",
		email: user?.data?.me?.email ?? "",
		fincatyc: user?.data?.me?.is_terms_and_conditions_accepted ?? false,
	});

	const [errors, setErrors] = useState<FormErrorTypes>({
		name: false,
		phone: false,
		email: false,
		fincatyc: false,
	});

	useEffect(() => form.setFieldsValue({ date: selectedDate }), [selectedDate]);

	const reset = () => {
		resetForm();
		form.resetFields();
	};

	useEffect(() => {
		Router.events.on("routeChangeStart", reset);
		return () => Router.events.on("routeChangeStart", reset);
	}, []);

	useEffect(() => {
		setFormData(getInitialContactForm());
		setSelectedCountryCode(getInitCountryCode());
	}, []);

	useEffect(() => {
		if (user.data && user.data?.me) {
			const phone = user.data?.me?.phone || "";
			try {
				try {
					const parsedPhoneNumber = parsePhoneNumberWithError(phone);
					setSelectedCountryCode({
						code: parsedPhoneNumber?.country,
						value: `+${parsedPhoneNumber?.countryCallingCode}`,
					});
					form.setFieldsValue({
						nombre: user?.data?.me?.name,
						telefono: parsedPhoneNumber?.nationalNumber,
						email: user?.data?.me?.email,
						fincatyc: user.data?.me?.is_terms_and_conditions_accepted,
					});
					setFormData({
						...formData,
						phone: parsedPhoneNumber?.nationalNumber,
						fincatyc: user.data?.me?.is_terms_and_conditions_accepted,
					});
				} catch (error) {
					const parsedPhoneNumber = parsePhoneNumberWithError(
						phone,
						selectedCountryCode?.code
					);
					const isValidNumber = isValidPhoneNumber(phone, selectedCountryCode?.code);

					if (isValidNumber) {
						setSelectedCountryCode({
							code: parsedPhoneNumber?.country,
							value: `+${parsedPhoneNumber?.countryCallingCode}`,
						});
						form.setFieldsValue({
							nombre: user?.data?.me?.name,
							telefono: parsedPhoneNumber?.nationalNumber,
							email: user?.data?.me?.email,
							fincatyc: user.data?.me?.is_terms_and_conditions_accepted,
						});
						setFormData({
							...formData,
							phone: parsedPhoneNumber?.nationalNumber,
							fincatyc: user.data?.me?.is_terms_and_conditions_accepted,
						});
						console.error(error);
					} else {
						throw new Error("Invalid phone number");
					}
				}
			} catch (error) {
				form.setFieldsValue({
					nombre: user?.data?.me?.name,
					telefono: phone,
					email: user?.data?.me?.email,
					fincatyc: user.data?.me?.is_terms_and_conditions_accepted,
				});
				setFormData({
					...formData,
					phone,
					fincatyc: user.data?.me?.is_terms_and_conditions_accepted,
				});
				console.error(error);
			} finally {
			}
		} else {
			setSelectedCountryCode(getInitCountryCode());
			setFormData(getInitialContactForm());
		}
	}, [user.data, user.data?.me]);

	useEffect(() => {
		if (formCompleted) {
			const categoryName: string = "formulario";

			FP.StandardEvent("CompleteRegistration");
		}
	}, [formCompleted]);

	useEffect(() => {
		if (dataRegisterMutation) {
			refreshAuth(dataRegisterMutation.registerIndividual);
		}
	}, [dataRegisterMutation]);

	useEffect(() => {
		if (dataUserExist) {
			openAuthModal({ withPromise: true, email: form.getFieldsValue().email })
				.then(({ data }) => {
					updateUser({
						name: form.getFieldsValue().name,
						phone: form.getFieldsValue().phone,
					}).then(data => {
						doContactMutation();
					});
				})
				.catch(error => {
					//if(onComplete) onComplete();
				});
		}
	}, [dataUserExist]);

	const refreshAuth = data => {
		cookie.set("frontend_token", data.access_token, {
			expires: 365,
			domain: loginBasePath,
			path: "/",
		});
		localStorage.setItem("user_md5", data.user_md5);
		user.refetch();
	};

	const validateMessages = {
		required: "El ${label} es requerido!",
		types: {
			email: "El ${label} no es válido!",
			number: "El ${label} no es un número válido!",
		},
	};

	const submitForm = () => {
		if (!formData.fincatyc) {
			// Valida si los Términos y Condiciones se han aceptado
			setErrors(values => ({ ...values, fincatyc: true }));
			return;
		}
		if (!formData.name) {
			setErrors(values => ({ ...values, name: true }));
		}
		if (
			!formData.phone ||
			!isValidPhoneNumber(String(formData?.phone), selectedCountryCode?.code) ||
			phoneStartWithIndicative(selectedCountryCode?.value, formData?.phone)
		) {
			setErrors(values => ({ ...values, phone: true }));
		}
		if (!formData.email) {
			setErrors(values => ({ ...values, email: true }));
		}

		if (errors.name || errors.phone || errors.email || errors.fincatyc) {
			return;
		}

		form.validateFields()
			.then(values => {
				values.isFromPaidTraffic = isFromPaidTraffic;
				values.isCoordinatingVisit = true;
				const newValues = {
					...values,
					...formData,
					phone: `${selectedCountryCode?.value}${formData.phone}`,
				};
				if (isLoggedIn) {
					sendContact(newValues);
				} else {
					userExistsCustomQuery({ variables: { email: formData.email } }).then(data => {
						if (data?.error?.message?.includes("no existe")) {
							return registerMutation({
								variables: {
									email: formData.email,
									name: formData.name,
								},
							})
								.then(({ data }) => {
									updateUser({
										name: formData.name,
										phone: selectedCountryCode.value + formData.phone,
									}).then(() => {
										sendContact(newValues);
									});
								})
								.catch(error => {
									console.error(error);
								});
						} else {
							const visitDate = new Date(newValues.date);
							doContactMutation(0, true, {
								name: newValues.name,
								email: newValues.email,
								phone: newValues.phone,
								type: isProject ? "PROJECT" : "PROPERTY",
								property_id: id,
								isFromPaidTraffic: newValues?.isFromPaidTraffic,
								date: newValues?.date
									? `${visitDate.getFullYear()}-${visitDate.getMonth() +
											1}-${visitDate.getDate()}`
									: null,
								visit_type:
									newValues?.visit_type == "INPERSON"
										? VisitType.INPERSON
										: VisitType.VIRTUAL,
								is_terms_and_conditions_accepted: formData.fincatyc,
							});
						}
					});
				}

				if (isProjectSpecialPage && slug && projectId) {
					let host = window.location.host;
					let TEST_HOST = "xn--4v8h.infocasas.com.uy";
					if (host === TEST_HOST || host === "localhost:3000") {
						host = "beta.infocasas.com.uy";
					}
					const msj = `Me gustaría agendar una visita ${
						values.visit_type
					}. Tengo disponibilidad el: ${dayjs(values.date).format("DD/MM/YYYY")}`;
					let reqEndpoint = `https://${host}/?mid=proyectos&func=landingDinamica&slug=${slug}&formulario&IDproyecto=${projectId}&json&nl`;
					let body = {
						nombre: formData.name,
						email: formData.email,
						fincatyc: formData.fincatyc,
						tel: `${selectedCountryCode?.value}${formData.phone}`,
						extra: msj,
						extra_completo: `${msj}.slug:${slug}`,
						InfoLeads: 1,
					};

					console.log("BODY : ", body);

					fetch(reqEndpoint, {
						method: "POST",
						body: JSON.stringify(body),
					}).then(res => {
						//
					});
				}
			})
			.catch(info => console.log("Validate Failed:", info));
	};

	const handleShowModal = () => {
		setShow(!show);
	};

	const handleFincaTYC = (e: React.ChangeEvent<HTMLInputElement>) => {
		const isChecked = e.target.checked ?? false;
		setFormData(values => ({ ...values, fincatyc: isChecked }));
		setErrors(values => ({ ...values, fincatyc: !isChecked }));
	};

	const handleCountryChange = value => {
		setSelectedCountryCode(value);
		handleBlur({ target: { value: formData?.phone } }, "phone");
	};

	const handleBlur = (e: React.FocusEvent<HTMLInputElement>, fieldName: string) => {
		const value = e.target.value;
		localStorage.setItem("contactForm", JSON.stringify(formData));
		localStorage.setItem("selectedCountryCode", JSON.stringify(selectedCountryCode));

		if (fieldName === "name") {
			const isValid = value.trim() !== "" && isValidCharactersXSS(value);
			setErrors({ ...errors, name: !isValid });
		} else if (fieldName === "phone") {
			setErrors({
				...errors,
				phone:
					!isValidPhoneNumber(String(value), selectedCountryCode?.code) ||
					phoneStartWithIndicative(selectedCountryCode?.value, formData?.phone),
			});
		} else if (fieldName === "email") {
			const isValid = value.trim() !== "" && isValidEmail(value);
			setErrors({ ...errors, email: !isValid });
		}
	};

	return (
		<>
			<Form
				form={form}
				name={"leadForm_" + identifier}
				initialValues={{
					visit_type: "VIRTUAL",
					date: selectedDate,
				}}
				onSubmitCapture={submitForm}
				labelCol={{ span: 0 }}
				scrollToFirstError
				validateMessages={validateMessages}>
				<Form.Item
					labelCol={{ span: 24 }}
					name="visit_type"
					label={
						<Space>
							<Text type={"secondary"}>{"Tipo de Visita"}</Text>
							<Popover
								placement={!screens.lg ? "bottom" : "top"}
								overlayClassName={"note-popover"}
								content={
									"Selecciona el tipo de visita que prefieras: Virtual para un recorrido online o Presencial para ver la propiedad en persona."
								}>
								<QuestionCircleOutlined />
							</Popover>
						</Space>
					}>
					<Radio.Group buttonStyle="solid" className={"visit-type-radio"}>
						<Radio.Button value="INPERSON" disabled={disabled}>
							{"En Persona"}
						</Radio.Button>
						<Radio.Button value="VIRTUAL" disabled={disabled}>
							{"Virtual"}
						</Radio.Button>
					</Radio.Group>
				</Form.Item>
				<Form.Item name="date" label={"Fecha"} style={{ display: "none" }}>
					<Input />
				</Form.Item>
				<Form.Item>
					<DateSelector
						selected={selectedDate}
						onSelect={setSelectedDate}
						disabled={disabled}
					/>
				</Form.Item>
				<Row gutter={12} style={{ marginBottom: 10 }}>
					<Col span={24}>
						<div className="container-input">
							<input
								className={"contact-form-input " + (errors.name ? "error" : "")}
								name="nombre"
								placeholder="Nombre"
								disabled={disabled}
								value={formData.name}
								onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
									setFormData({ ...formData, name: e.target.value })
								}
								onBlur={e => handleBlur(e, "name")}
								required></input>
							{errors.name && <span className="error-message">Nombre no válido</span>}
						</div>
					</Col>
				</Row>
				<div style={{ display: "flex", marginBottom: 10, gap: ".8rem" }}>
					<div className="container-input" style={{ width: "auto" }}>
						<CountriesDropdown
							onChange={handleCountryChange}
							countryCode={selectedCountryCode}
						/>
					</div>

					<div className="container-input" style={{ width: "auto" }}>
						<input
							className={"contact-form-input " + (errors.phone ? "error" : "")}
							name="telefono"
							placeholder="Teléfono"
							disabled={disabled}
							value={formData.phone}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
								const phone = e?.target?.value?.replace(/\D/g, "");
								setFormData({
									...formData,
									phone,
								});
								handleBlur({ target: { value: phone } }, "phone");
							}}
							onBlur={e => handleBlur(e, "phone")}
							type="tel"
							required></input>
						{errors.phone && <span className="error-message">Teléfono no válido</span>}
					</div>
				</div>
				<div className="container-input">
					<input
						className={"contact-form-input " + (errors.email ? "error" : "")}
						name="email"
						type="email"
						placeholder="Email"
						disabled={disabledEmail || disabled}
						value={formData.email}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
							setFormData({ ...formData, email: e.target.value })
						}
						onBlur={e => handleBlur(e, "email")}
						required></input>
					{errors.email && <span className="error-message">Email no válido</span>}
				</div>

				{country_code === "CO" && !user?.data?.me?.is_terms_and_conditions_accepted && (
					<CheckboxCustomInput
						className="tycfinca"
						value="fincatyc"
						id="fincatyc"
						onChange={handleFincaTYC}
						hasError={errors.fincatyc}>
						Aceptas nuestros{" "}
						<a href="/informacion#terminos-y-condiciones" target="_blank">
							Términos y condiciones
						</a>{" "}
						y{" "}
						<a href="/informacion#politicas-de-privacidad" target="_blank">
							Política de privacidad
						</a>
					</CheckboxCustomInput>
				)}
				{country_code !== "CO" && country_code !== "BR" && !isProject && (
					<div className="container-busca-por-ti">
						<Form.Item
							name="busca_por_ti"
							valuePropName="checked"
							className="container-busca-por-ti">
							<Checkbox disabled={disabled}>
								{`Quiero que ${site_name} busque por mí`}
							</Checkbox>
						</Form.Item>

						<button onClick={handleShowModal} className="info-btn">
							<QuestionIcon width={20} height={20} />
						</button>
					</div>
				)}

				<Form.Item style={{ marginTop: 10 }}>
					<LeadButtons
						id={id}
						mode={mode}
						disabled={disabled}
						isProject={isProject}
						projectId={projectId}>
						<Button
							type="primary"
							loading={loading}
							disabled={
								formCompleted || disabled || isSendedConsultation.coordinateVisit
							}
							className="btn-send-lead"
							id="btn-send-lead"
							onClick={submitForm}>
							{isSendedConsultation.coordinateVisit
								? "Enviado"
								: loading
								? "Enviando"
								: "Coordinar Visita"}
						</Button>
					</LeadButtons>
				</Form.Item>
			</Form>

			{show && country_code !== "CO" && (
				<IcBuscaPorTi onClose={handleShowModal} showButtons={false} />
			)}
		</>
	);
};

